import styled from "styled-components";

export const SortIconWrapper = styled.div<{ status?: number }>`
  text-align: center;
  height: 1rem;
  width: 1rem;
`;
